(() => {
  const selector = '.nl-related-range__track, .ng-aq-track, .product-recommendations--container .product-row, .featured-collection__container .product-row, .product-recently-viewed__content';
  const desktop = matchMedia('(min-width:720px)');
  const prepared = new WeakMap();
  const usable = row => !row.classList.contains('flickity-enabled') && !row.querySelector('.flickity-viewport') && !row.closest('[data-product-recommendations]')?.querySelector('.ng-plant-slider-nav');
  const prepare = root => {
    const rows = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) rows.push(root);
    rows.forEach(row => {
      if (prepared.has(row)) { prepared.get(row)(); return; }
      if (!usable(row)) return;
      row.classList.add('nl-carousel-scroll');
      if (!row.hasAttribute('tabindex')) row.tabIndex = 0;
      const heading = row.closest('section, aside')?.querySelector('h2');
      if (heading && !row.hasAttribute('aria-label')) row.setAttribute('aria-label', heading.textContent.trim());
      const frame = document.createElement('div');
      frame.className = 'nl-carousel-frame';
      row.before(frame);
      frame.append(row);
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'nl-carousel-next';
      next.setAttribute('aria-label', 'Next products');
      next.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
      frame.append(next);
      const previous = document.createElement('button');
      previous.type = 'button';
      previous.className = 'nl-carousel-next nl-carousel-previous';
      previous.setAttribute('aria-label', 'Previous products');
      previous.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg>';
      frame.append(previous);
      const update = () => {
        const max = Math.max(0, row.scrollWidth - row.clientWidth);
        const inactive = !usable(row) || max <= 2;
        previous.hidden = inactive || row.scrollLeft <= 2;
        next.hidden = inactive || row.scrollLeft >= max - 2;
      };
      const move = direction => {
        const max = Math.max(0, row.scrollWidth - row.clientWidth);
        row.scrollTo({left: Math.max(0, Math.min(max, row.scrollLeft + direction * row.clientWidth * 0.9)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      row.addEventListener('scroll', update, {passive:true});
      prepared.set(row, update);
      next.addEventListener('click', () => move(1));
      new ResizeObserver(update).observe(row);
      new MutationObserver(update).observe(row, {childList:true, attributes:true, attributeFilter:['class']});
      update();
    });
  };
  const stopMouseDrag = event => {
    if (!desktop.matches || (event.type === 'pointerdown' && event.pointerType !== 'mouse')) return;
    const row = event.target instanceof Element ? event.target.closest(selector) : null;
    if (row && !event.target.closest('button,input,select,textarea')) event.stopPropagation();
  };
  document.addEventListener('pointerdown', stopMouseDrag, true);
  document.addEventListener('mousedown', stopMouseDrag, true);
  document.addEventListener('dragstart', event => {
    if (desktop.matches && event.target instanceof Element && event.target.closest(selector)) event.preventDefault();
  });
  document.addEventListener('keydown', event => {
    const row = event.target instanceof Element ? event.target.closest(selector) : null;
    if (!row || !usable(row) || event.target !== row || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    if (event.key === 'Home') row.scrollTo({left:0});
    else if (event.key === 'End') row.scrollTo({left:row.scrollWidth});
    else row.scrollBy({left:(event.key === 'ArrowRight' ? 1 : -1) * row.clientWidth * 0.8});
  });
  const start = () => {
    prepare(document);
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (node instanceof Element) prepare(node);
    }))).observe(document.body, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
